import type { ReactElement } from 'react';
import { skeletonLine } from '@/components/ui/skeleton';

/** Skeleton contextual que imita la forma de la tabla (UX-LOAD-01), no un spinner. */
export function TableSkeleton({
  columns,
  rows = 8,
}: {
  columns: string[];
  rows?: number;
}): ReactElement {
  return (
    <div className="card" aria-busy="true" aria-label="Cargando documentos">
      <table className="t">
        <thead>
          <tr>
            {/* Key por posición: un campo propio puede llamarse igual que otra columna. */}
            {/* La columna sin título es la de acciones: como en la tabla real, se nombra
                solo para lectores de pantalla (axe: empty-table-header). */}
            {columns.map((c, i) => (
              <th key={i}>{c === '' ? <span className="sr-only">Acciones</span> : c}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, r) => (
            <tr key={r}>
              {columns.map((_, i) => (
                <td key={i}>
                  <div className={skeletonLine({ width: i === 0 ? 'xs' : 80 })} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
